import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

const GET_QUIZ_COMPLETION_CERTIFICATE = gql`
  query completionCertificate($certificateId: String!) {
    completionCertificate(certificateId: $certificateId) {
      imageUrl
      verifyUrl
      userId
    }
  }
`;

const GetCompletionCertificate = ({ children, data }) => children(data);

export default graphql(GET_QUIZ_COMPLETION_CERTIFICATE, {
  options: ({ certificateId }) => ({ variables: { certificateId } })
})(GetCompletionCertificate);

export { GET_QUIZ_COMPLETION_CERTIFICATE };
